export default __webpack_public_path__ + "static/media/Surgery.35662896.jpg";